import React from "react";
import { Link } from "react-router-dom";

const SimulacrumImagesFooter = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="site-footer-shell">
                <div className="site-footer-links">
                    <Link to="/services">Services</Link>
                    <Link to="/contact">Start a project</Link>
                    <a
                        href="https://www.instagram.com/simulacrum.img/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Instagram
                    </a>
                    <a
                        href="https://x.com/Simulacrum_img"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        X
                    </a>
                    <a
                        href="https://www.kylehintonprojects.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Kyle Hinton Projects
                    </a>
                    <Link to="/privacy">Privacy</Link>
                    <Link to="/terms">Terms</Link>
                    <Link to="/copyright">Copyright</Link>
                </div>
                <p className="site-footer-contact">
                    Project enquiries: <a href="mailto:kyle-hinton@outlook.com">kyle-hinton@outlook.com</a>
                </p>
                <p className="site-footer-copy">
                    {`Copyright © ${year} Simulacrum Images. All rights reserved.`}
                </p>
            </div>
        </footer>
    );
};

export default SimulacrumImagesFooter;
